import React from 'react';
import { Input, Table, Tag } from 'antd';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { priceRender, renderWithTooltip } from 'utils/table';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { formatDate } from 'utils';

function OptionsTable({
  items,
  current,
  pageSize,
  loading,
  total,
  onChange,
  onRowClick,
}) {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Наименование',
      dataIndex: 'title',
      key: 'title',
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по наименованию"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.title?.toLowerCase().includes(value.toLowerCase());
      },
      render: (value) => renderWithTooltip(value),
    },
    {
      title: 'Цена (₸)',
      dataIndex: 'price',
      key: 'price',
      render: priceRender,
    },
    {
      title: 'Период',
      dataIndex: 'period',
      key: 'period',
    },
    {
      title: 'Скидка',
      dataIndex: 'discount_percent',
      key: 'discount_percent',
      render: (discount) => discount || '---',
    },
    {
      title: 'Промокод',
      dataIndex: 'withPromo',
      key: 'withPromo',
      render: (withPromo) => <Tag>{withPromo ? 'Да' : 'Нет'}</Tag>,
      filters: [
        {
          text: 'C промокодом',
          value: true,
        },
        {
          text: 'Без промокода',
          value: false,
        },
      ],
      onFilter: (value, record) => record.withPromo === value,
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: 'Доступен',
      dataIndex: 'isPublic',
      key: 'isPublic',
      render: (isPublic) => (
        <Tag сolor={isPublic ? 'green' : 'red'}>{isPublic ? 'Да' : 'Нет'}</Tag>
      ),
      filters: [
        {
          text: 'Доступные',
          value: true,
        },
        {
          text: 'Не доступные',
          value: false,
        },
      ],
      onFilter: (value, record) => record.isPublic === value,
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: 'Дата создания',
      dataIndex: 'created',
      key: 'created',
      render: (value) => formatDate(value),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      tableLayout="fixed"
      pagination={{
        current,
        pageSize,
        total,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { OptionsTable };
